import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import {
  getUser,
  getLoadingState,
} from '@redux/selectors/UserSelector';
import { getSelectedListingData, selectCurrentListing } from '@redux/selectors/ListingSelector';

import Badge from '@mui/material/Badge';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Zendesk, { ZendeskAPI } from './ZendeskConfig';

const ZendeskChat = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const isLoading = useSelector(getLoadingState);
  const user = useSelector(getUser);
  const currentListing = useSelector(selectCurrentListing);
  const selectedListing = useSelector(getSelectedListingData);
  let listingId;

  if (selectedListing) listingId = selectedListing.ListingId;
  else if (currentListing) listingId = currentListing.ListingId;

  const handleOpen = () => {
    ZendeskAPI('messenger', 'open');

    let aor;

    if (!isLoading) {
      // Member ID
      ZendeskAPI('messenger:set', 'conversationFields', [{ id: 6007868926491, value: user.MemberMlsId }]);
      // First Name
      ZendeskAPI('messenger:set', 'conversationFields', [{ id: 6013247923099, value: user.MemberFirstName }]);
      // Last Name
      ZendeskAPI('messenger:set', 'conversationFields', [{ id: 6013249823003, value: user.MemberLastName }]);
      // Email Address
      ZendeskAPI('messenger:set', 'conversationFields', [{ id: 12878322811419, value: user.MemberEmail }]);
      // Board
      switch (user.MemberAOR.toLowerCase()) {
        case 'creb':
        case 'awra':
        case 'cara':
        case 'fmreb':
        case 'gpaar':
        case 'ldar':
        case 'rald':
        case 'mhreb':
        case 'rasca':
        case 'area':
        case 'rae':
          aor = `ticket_cf_tag_aor_${user.MemberAOR.toLowerCase()}`;
          break;
        default:
          aor = 'ticket_cf_tag_aor_na';
          break;
      }
      ZendeskAPI('messenger:set', 'conversationFields', [{ id: 18788486062363, value: aor }]);
    }
    // Listing ID
    if (listingId) ZendeskAPI('messenger:set', 'conversationFields', [{ id: 6224018977691, value: listingId }]);
  };

  const handleLoaded = () => {
    ZendeskAPI('messenger', 'close');
    ZendeskAPI('messenger:on', 'unreadMessages', count => setUnreadCount(count));
  };

  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={(
          <Tooltip id="tooltip-p9-chat" style={{ margin: 0 }}>
            Pillar 9™ Support Centre
            <br />
            Chat & Knowledgebase
          </Tooltip>
        )}
      >
        <a
          href="#"
          aria-label="Pillar 9™ Chat"
          target="_self"
          rel="noreferrer"
          onClick={handleOpen}
        >
          <div className={unreadCount > 0 ? 'jello-horizontal' : ''}>
            <Badge
              badgeContent={unreadCount}
              color="error"
              max={9}
            >
              <i className="fas fa-comment-alt-smile fa-lg" />
            </Badge>
          </div>
        </a>
      </OverlayTrigger>
      <Zendesk defer zendeskKey={process.env.REACT_APP_ZENDESK_KEY} onLoaded={handleLoaded} />
    </>
  );
};

export default ZendeskChat;
